import React from "react";
import { Stack } from "expo-router/stack";

import { useSession } from "@/context/auth/useSession";
import LoadingScreen from "@/screens/Loading/LoadingScreen";

export default function Layout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack.Screen
        name="home"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="explore-by-category"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
